<template>
    <div class="te-loyalty-payment-methods">
        <div class="te-cart-heading">{{languageSettings.loyaltyPayment}}</div>
        <ul class="te-loyalty-payment-methods-list">
            <li v-for="(requiredLoyaltyCardPayment, i) in value"
                :key="i"
            >
                <div class="te-loyalty-payment">
                    <div class="te-loyalty-payment__card-type">
                        {{requiredLoyaltyCardPayment.cardType}}
                    </div>
                    <div class="te-loyalty-payment__card-detail">
                        <div class="te-loyalty-payment__card-number"><input class="te-form-control" type="text" name="card-id" :value="requiredLoyaltyCardPayment.cardId" :placeholder="languageSettings.cardIdPlaceholder" @input="onSetCardField($event.target.value, 'cardId', i)"></div>
<!--                        <div class="te-loyalty-payment__card-pin"><input class="te-form-control" type="password" name="card-pin" :value="requiredLoyaltyCardPayment.cardPin" :placeholder="languageSettings.cardPinPlaceholder" @input="onSetCardField($event.target.value, 'cardPin', i)"></div>-->
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "LoyaltyPaymentMethod",

        data() {
            return {
                // method: null,
            };
        },

        props: {
            value: {
                type: Array
            },
            language: {
                type: Object
            },
        },

        computed: {
            languageSettings: function() {
                const defaultSettings = {
                    loyaltyPayment: 'Loyalty payment',
                    cardIdPlaceholder: 'Card number',
                    cardPinPlaceholder: 'Card pin',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            // selectMethod(method) {
            //     this.method = method;
            //     this.$emit('change', this.method);
            // },

            onSetCardField(value, key, requiredLoyaltyPaymentIndex) {
                const rlp = this.value.map((x) => x);
                rlp[requiredLoyaltyPaymentIndex][key] = value;
                this.$emit('input', rlp)
            },

            // onSetCardPin(cardPin, requiredLoyaltyPaymentIndex) {
            //     const rlp = this.requiredLoyaltyCardPayments.map((x) => x);
            //     rlp[requiredLoyaltyPaymentIndex].cardPin = cardPin;
            //     this.$emit('input', rlp)
            // },

        },

//         watch: {
//             value: function(requiredLoyaltyCardPayments) {
// console.log(requiredLoyaltyCardPayments);
//             }
//         },

    }
</script>

<style scoped>

</style>
